<template>
</template>

<script>

import Vuex from 'vuex'
import Storage from '@/helpers/storage'
import Tracking from '@/modules/tracking'

export default {

    name: 'optimize-trigger',

    computed: {

        ...Vuex.mapGetters(['page', 'lang'])

    },

    watch: {

        page: function () {

            this.trigger()

        },

        lang: function () {

            this.trigger()

        }

    },

    methods: {

        trigger() {

            if (dataLayer) {

                const page = `optimize-${this.page}`
                const pageLang = `optimize-${this.page}-${this.lang}`
                const pageUtmSource = `optimize-${this.page}-${Tracking.getTracking().utm_source}`

                if (Storage.getItem('debugOptimize')) {
                    console.debug(`${page} ${pageLang} ${pageUtmSource}`)
                }

                dataLayer.push({'event': page})
                dataLayer.push({'event': pageLang})
                dataLayer.push({'event': pageUtmSource})
            }

        }
    }

}
</script>

<style lang="scss" scoped></style>
